export default "/metamask.f62fbcf2ee50ad30a6cc3003ee80aea2.svg";